import { Box, Text, Stack, Group, Progress } from "@mantine/core";

type Props = {
  percent: number;
  total: number;
};

export default function AssessmentProgressPanel({ percent, total }: Props) {
  return (
    <Box
      p="md"
      style={{
        backgroundColor: "#ffffff",
        borderTop: "1px solid var(--mantine-color-slate-2)",
      }}
    >
      <Group justify="space-between" align="center" wrap="nowrap" mb="sm">
        <Text fw={700} fz="sm" c="dark.7">
          Your Progress
        </Text>
        <Text fz="sm" fw={600} c="primary.8">
          {total}
        </Text>
      </Group>

      <Stack gap={4}>
        <Group justify="space-between" align="baseline" wrap="nowrap">
          <Text fw={700} fz="xl" c="primary.8" lh={1.1}>
            {percent}%
          </Text>
          <Text fz="xs" c="slate.5">
            Complete
          </Text>
        </Group>
        <Progress
          value={percent}
          size={6}
          radius="xl"
          styles={{
            root: { backgroundColor: "var(--mantine-color-primary-1)" },
            section: { backgroundColor: "var(--mantine-color-primary-6)" },
          }}
          aria-label="Overall progress"
        />
      </Stack>
    </Box>
  );
}
